import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import _get from 'lodash-es/get';

import { CheckCircleFill } from 'sushiweb/Icons';
import green from 'sushiweb/tokens/color/green';
import red from 'sushiweb/tokens/color/red';
import H4 from 'sushiweb/Typography/Heading/H4';
import { P } from 'sushiweb/Typography/Text';
import CrossCircleFill from 'sushiweb/Icons/all/CrossCircleFill';
import Spinner from 'sushiweb/Spinner/Spinner';
import TimeFill from 'sushiweb/Icons/all/TimeFill';
import yellow from 'sushiweb/tokens/color/yellow';

import {
  DashboardWrapper,
  OnlinePaymentCenterAlign,
  OnlinePaymentStatusHeader,
  SpinnerHolder,
} from '../../common/styles';
import useOnlinePaymentPolling from '../../common/utils/useOnlinePaymentPolling';
import { paymentStatusEnum } from '../../common/components/constants';
import { GET_PAYMENT_INFO } from '../../../constants/urls';
import ErrorPage from '../../common/components/ErrorPage';
import { formatAmountInRupees, queryVariableValue } from '../../../helpers';

const OnlinePaymentResponsePage = () => {
  const [isOrderIDpresent, orderIDValue] = queryVariableValue('order_id');
  const [pollingCounter, setPollingCounter] = useState(0);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [isResponseError, setIsResponseError] = useState(false);
  const [isPollingStarted, setIsPollingStarted] = useState(true);
  const [pollingFrequency, setPollingFrequency] = useState(2);
  const [paymentState, setPaymentState] = useState(
    paymentStatusEnum.INITIATED_PENDING,
  );
  const [paymentAmount, setPaymentAmount] = useState(0);
  const terminalStates = [
    paymentStatusEnum.APPROVED_SUCCESS,
    paymentStatusEnum.DECLINED,
    paymentStatusEnum.FAILED,
    paymentStatusEnum.SUCCESS,
    paymentStatusEnum.VOID_FAILED,
    paymentStatusEnum.REFUNDED,
    paymentStatusEnum.PARTIALLY_REFUNDED,
  ];
  const RedirectPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
      const timer = setTimeout(() => {
        navigate(`/payments?order_id=${orderIDValue}`);
      }, 4000);

      return () => clearTimeout(timer);
    }, [navigate]);

    return <div />;
  };

  const onResponse = ({ isError, response }) => {
    setPollingCounter(pollingCounter + 1);
    const respStatus = _get(response, 'status_response.status', false);
    setIsResponseError(!respStatus);
    const status = _get(response, 'data.status', 0);
    const amount = _get(response, 'data.amount', 0);
    setPaymentAmount(amount);
    setIsPageLoading(false);
    if (isError) {
      setIsPollingStarted(false);
      return;
    }
    if (!respStatus) {
      setIsPollingStarted(false);
    }

    if (terminalStates.includes(status)) {
      if (status === paymentStatusEnum.FAILED) {
        setPaymentState(paymentStatusEnum.FAILED);
      } else if (status === paymentStatusEnum.SUCCESS) {
        setPaymentState(paymentStatusEnum.SUCCESS);
      } else {
        setPaymentState(paymentStatusEnum.PENDING);
      }
      setIsPollingStarted(false);
    } else {
      setPollingFrequency(3);
    }
  };

  useOnlinePaymentPolling({
    paymentReferenceID: orderIDValue,
    frequency: pollingFrequency,
    isPollingStarted,
    onResponse,
    url: GET_PAYMENT_INFO,
  });

  useEffect(() => {
    if (pollingCounter === 10) {
      if (paymentState !== paymentStatusEnum.SUCCESS) {
        setPaymentState(paymentStatusEnum.PENDING);
      }
      setIsPollingStarted(false);
    }
  }, [pollingCounter]);

  if (isResponseError || !isOrderIDpresent) {
    return (
      <>
        <DashboardWrapper>
          <ErrorPage />
        </DashboardWrapper>
      </>
    );
  }
  return (
    <>
      {isPageLoading ? (
        <DashboardWrapper>
          <SpinnerHolder className='center'>
            <Spinner color={red.z_red} size='medium' />
          </SpinnerHolder>
        </DashboardWrapper>
      ) : (
        <DashboardWrapper>
          {paymentState === paymentStatusEnum.SUCCESS && (
            <>
              <OnlinePaymentStatusHeader>
                <OnlinePaymentCenterAlign>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <CheckCircleFill
                        color={green.z500}
                        size='15rem'
                        style={{ padding: '10px 30px 30px 30px' }}
                      />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      {' '}
                      <H4>
                        Your payment of
                        {' '}
                        {formatAmountInRupees(paymentAmount)}
                        {' '}
                        is
                        successful.
                      </H4>
                      {' '}
                    </div>
                    <br />
                    {' '}
                    <br />
                    <P>Redirecting you back to the `Payments` section</P>
                    <RedirectPage />
                  </div>
                </OnlinePaymentCenterAlign>
              </OnlinePaymentStatusHeader>
            </>
          )}
          {paymentState === paymentStatusEnum.INITIATED_PENDING && (
            <SpinnerHolder className='center'>
              <Spinner color={red.z_red} size='medium' />
            </SpinnerHolder>
          )}
          {paymentState === paymentStatusEnum.PENDING && (
            <>
              <OnlinePaymentStatusHeader>
                <OnlinePaymentCenterAlign>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <TimeFill
                        color={yellow.z500}
                        size='15rem'
                        style={{ padding: '10px 30px 30px 30px' }}
                      />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      {' '}
                      <H4>
                        Your payment of
                        {' '}
                        {formatAmountInRupees(paymentAmount)}
                        {' '}
                        is
                        pending
                      </H4>
                      {' '}
                    </div>
                    <br />
                    {' '}
                    <br />
                    <P>
                      If money was deducted, a refund will be automatically
                      initiated within 24 hours.
                      {' '}
                      <br />
                      Redirecting you back to the `Payments` section
                    </P>
                    <RedirectPage />
                  </div>
                </OnlinePaymentCenterAlign>
              </OnlinePaymentStatusHeader>
            </>
          )}
          {paymentState === paymentStatusEnum.FAILED && (
            <>
              <OnlinePaymentStatusHeader>
                <OnlinePaymentCenterAlign>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <CrossCircleFill
                        color={red.z500}
                        size='15rem'
                        style={{ padding: '10px 30px 30px 30px' }}
                      />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      {' '}
                      <H4>
                        Payment of
                        {' '}
                        {formatAmountInRupees(paymentAmount)}
                        {' '}
                        failed
                        {' '}
                        <br />
                      </H4>
                      {' '}
                    </div>
                    <br />
                    {' '}
                    <br />
                    <P>
                      If money was deducted, a refund will be automatically
                      initiated within 24 hours.
                      {' '}
                      <br />
                      Redirecting you back to the `Payments` section
                    </P>
                    <RedirectPage />
                  </div>
                  <br />
                  {' '}
                  <br />
                </OnlinePaymentCenterAlign>
              </OnlinePaymentStatusHeader>
            </>
          )}
        </DashboardWrapper>
      )}
    </>
  );
};

export default OnlinePaymentResponsePage;
